import styled from 'styled-components'

/**
 * OB-499: Native <button>. Was styled.TouchableOpacity from
 * styled-components/native. Click handling now goes through the browser's
 * own hit-testing only.
 */
export const CartButton = styled.button<{
  bgColor: string
  borderColor: string
  isDesktop: boolean
}>`
  position: absolute;
  top: ${(props) =>
    props.isDesktop ? 'calc(680px - 68px)' : 'calc(100dvh - 68px)'};
  right: 16px;
  display: flex;
  flex-direction: row;
  background-color: ${(props) => props.bgColor};
  padding: 10px 20px;
  border-radius: 5px;
  border-color: ${(props) => props.borderColor};
  border-style: solid;
  border-width: 1px;
  appearance: none;
  cursor: pointer;
  font: inherit;
  align-items: center;
`

export const CartButtonText = styled.span<{ textColor: string }>`
  color: ${(props) => props.textColor};
  font-size: 18px;
  margin-right: 8px;
  font-family: 'ProximaNova-Regular', proxima-nova, 'Helvetica Neue', Helvetica,
    Arial, sans-serif;
`

export const CartButtonAmount = styled.span<{
  bgColor: string
  textColor: string
}>`
  color: ${(props) => props.textColor};
  font-size: 13px;
  background-color: ${(props) => props.bgColor};
  padding: 7px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  text-align: center;
  font-family: 'ProximaNova-Regular', proxima-nova, 'Helvetica Neue', Helvetica,
    Arial, sans-serif;
  display: inline-block;
  box-sizing: border-box;
`
